<template>
  <div class="compliance-footer">
    <div class="footer-left">
      <span class="service-statement">
        本平台面向公众提供科普与实践内容，不限定未成年人使用。
      </span>
    </div>
    <div class="footer-right">
      <button class="footer-link" @click="openDialog('privacy')">隐私政策</button>
      <span class="split">|</span>
      <button class="footer-link" @click="openDialog('agreement')">用户协议</button>
      <span class="split">|</span>
      <button class="footer-link" @click="openDialog('minor')">未成年人保护说明</button>
      <span class="split">|</span>
      <button class="footer-link" @click="openDialog('contact')">联系我们</button>
      <span class="split">|</span>
      <!-- <span class="record-text">ICP备案号：京ICP备2026027924号-1</span> -->
      <button class="footer-link" @click="openBeianSite">ICP备案号：京ICP备2026027924号-1</button>
      <span class="split">|</span>
      <!-- <a class="record-link" href="javascript:void(0)">公安备案链接（预留）</a> -->
      <a class="record-link" href="https://beian.mps.gov.cn/#/query/webSearch?code=11010502060954" rel="noreferrer" target="_blank"><img src="@/assets/plant/batb.png" alt="备案图标" class="beian-icon">&nbsp;京公网安备11010502060954号</a>
    </div>

    <!--
      合规说明：采用「仅内容面板」而非全屏遮罩。
      外层 pointer-events: none 让空白区域点击穿透到页面；仅白框可交互，阅读负担小于 el-dialog 遮罩。
    -->
    <transition name="compliance-panel-fade">
      <div
        v-show="dialogVisible"
        class="compliance-panel-layer"
        role="dialog"
        aria-modal="false"
        :aria-label="dialogTitle"
      >
        <div class="compliance-panel" @click.stop>
          <div class="compliance-panel-header">
            <span class="compliance-panel-title">{{ dialogTitle }}</span>
            <button
              type="button"
              class="compliance-panel-close"
              aria-label="关闭"
              @click="closeDialog"
            >
              ×
            </button>
          </div>
          <div class="compliance-panel-body dialog-content">
            <div v-if="dialogType === 'privacy'">
              <p>我们仅收集实现基础功能所需的信息（如账号标识、登录状态与学习记录），用于登录鉴权、功能使用和服务优化。</p>
              <p>我们不会在未经授权的情况下向第三方出售个人信息；如需共享，将基于合法、正当、必要原则并履行告知义务。</p>
              <p>用户可通过联系我们申请查询、更正或删除相关信息。具体保留期限以法律法规要求和业务必要期限为准。</p>
            </div>
            <div v-else-if="dialogType === 'agreement'">
              <p>本平台提供编程与场景化科普实践服务，用户应遵守法律法规，不得发布或传播违法违规内容。</p>
              <p>用户应妥善保管账号信息，对账号下发生的操作承担相应责任；如发现异常，请及时联系我们处理。</p>
              <p>平台可在法律允许范围内对服务内容进行升级、调整或维护，并提前以合理方式进行通知。</p>
            </div>
            <div v-else-if="dialogType === 'minor'">
              <p>未成年人应在监护人指导下使用本平台，合理安排学习与休息时间，避免深夜长时间使用。</p>
              <p>本平台当前不提供充值、打赏等资金交易功能；如后续上线相关能力，将依法完善规则并单独告知。</p>
              <p>本平台不提供陌生人社交功能，不设公开聊天广场或随机匹配交友场景。</p>
            </div>
            <div v-else>
              <p>联系邮箱：tcwj241207@163.com</p>
              <p>工作时间：周一至周五 09:00-18:00</p>
              <p>北京童程无界科技有限公司</p>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "ComplianceFooter",
  data() {
    return {
      dialogVisible: false,
      dialogType: "privacy",
      dialogTitleMap: {
        privacy: "隐私政策",
        agreement: "用户协议",
        minor: "未成年人保护说明",
        contact: "联系我们",
      },
    };
  },
  computed: {
    dialogTitle() {
      return this.dialogTitleMap[this.dialogType];
    },
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.onDocKeydown);
  },
  methods: {
    openDialog(type) {
      document.removeEventListener("keydown", this.onDocKeydown);
      this.dialogType = type;
      this.dialogVisible = true;
      document.addEventListener("keydown", this.onDocKeydown);
    },
    closeDialog() {
      this.dialogVisible = false;
      document.removeEventListener("keydown", this.onDocKeydown);
    },
    onDocKeydown(e) {
      if (e.key === "Escape") {
        this.closeDialog();
      }
    },
    // 添加新方法：打开备案网站
    openBeianSite() {
      window.open('https://beian.miit.gov.cn/', '_blank');
    }
  },
};
</script>

<style scoped>
.compliance-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2000;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 14px;
  box-sizing: border-box;
  font-size: 12px;
  color: #666;
  background: rgba(255, 255, 255, 0.96);
  border-top: 1px solid #e8e8e8;
}

.footer-left {
  min-width: 260px;
  margin-right: 12px;
}

.service-statement {
  white-space: nowrap;
}

.footer-right {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  overflow-x: auto;
}

.footer-link {
  border: none;
  background: transparent;
  color: #409eff;
  cursor: pointer;
  padding: 0;
  font-size: 12px;
}

.beian-icon {
  width: 14px;          /* 图标宽度 */
  height: 14px;         /* 图标高度 */
  object-fit: contain;  /* 保持图标比例 */
  vertical-align: middle;
}

.footer-link:hover,
.record-link:hover {
  color: #1e7de6;
}

.record-text {
  color: #666;
  white-space: nowrap;
}

.record-link {
  color: #409eff;
  text-decoration: none;
  white-space: nowrap;
}

.split {
  margin: 0 8px;
  color: #c0c4cc;
}

.dialog-content p {
  margin: 0 0 10px;
  line-height: 1.7;
  color: #444;
}

.dialog-content p:last-child {
  margin-bottom: 0;
}

.compliance-panel-layer {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 2100;
  pointer-events: none;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 8vh 16px 80px;
  box-sizing: border-box;
}

.compliance-panel {
  pointer-events: auto;
  width: 720px;
  max-width: calc(100vw - 32px);
  max-height: min(72vh, 640px);
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.12), 0 0 1px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.compliance-panel-header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  border-bottom: 1px solid #ebeef5;
}

.compliance-panel-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.compliance-panel-close {
  border: none;
  background: transparent;
  font-size: 22px;
  line-height: 1;
  color: #909399;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
}

.compliance-panel-close:hover {
  color: #409eff;
  background: #ecf5ff;
}

.compliance-panel-body {
  overflow-y: auto;
  padding: 16px 18px 20px;
}

.compliance-panel-fade-enter-active,
.compliance-panel-fade-leave-active {
  transition: opacity 0.2s ease;
}

.compliance-panel-fade-enter,
.compliance-panel-fade-leave-to {
  opacity: 0;
}

.compliance-panel-fade-enter-active .compliance-panel,
.compliance-panel-fade-leave-active .compliance-panel {
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.compliance-panel-fade-enter .compliance-panel,
.compliance-panel-fade-leave-to .compliance-panel {
  transform: translateY(-8px);
  opacity: 0.96;
}
</style>
